module.exports = __webpack_public_path__ + "img/colored_section-4.a66bdc67.svg";